import { useState } from 'react';
import { useIntl } from 'react-intl';
import { IconButton, InputAdornment, TextField } from 'components/ui';
import { Visibility, VisibilityOff } from 'components/uiIcons';

const Password = (field) => {
  const intl = useIntl();
  const [showPassword, setShowPassword] = useState(false);

  const toggleShowPassword = () => setShowPassword((prev) => !prev);

  return (
    <TextField
      type={showPassword ? 'text' : 'password'}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label={intl.formatMessage({ id: 'aria.password.toggle' })}
              aria-pressed={showPassword}
              onClick={toggleShowPassword}
              edge="end"
            >
              {showPassword
                ? <VisibilityOff aria-hidden="true" />
                : <Visibility aria-hidden="true" />}
            </IconButton>
          </InputAdornment>
        ),
      }}
      {...field}
    />
  );
};

export default Password;
